export const colors = {
    black: 'rgba(0, 0, 0, 0.72)',
    blue: '#2393FF',
    borderGrey: 'rgba(0,0,0,0.08)',
    captionGrey: '#78787c',
    lightBlue: '#eef7ff',
};
